// extracted by css-extract-rspack-plugin
export default {"joinCellItem":"rk8vX","isReadOnly":"W4uxO","hasColumnStyle":"uBohZ","isOpen":"kiuej","noColumnStyle":"NpCtL","joinCellContent":"hS1ao"};